import React from 'react';
import Input from '@/src/shared/components/Antd/Input';
import styles from './index.module.scss';
import clsx from 'clsx';

export const TextInput = ({
  placeholder,
  label,
  value,
  onChange,
  fullWidth = false,
}) => {
  return (
    <>
      <label className={styles.inputLabel}>{label}</label>
      <Input
        className={clsx(styles.input, {
          [styles.fullWidth]: fullWidth,
        })}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required
      />
    </>
  );
};
